import { render, staticRenderFns } from "./basicDetails.vue?vue&type=template&id=badc2880&scoped=true"
import script from "./basicDetails.vue?vue&type=script&lang=js"
export * from "./basicDetails.vue?vue&type=script&lang=js"
import style0 from "./basicDetails.vue?vue&type=style&index=0&id=badc2880&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "badc2880",
  null
  
)

export default component.exports